import React, { useEffect, useRef, useState } from "react";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
import Select from "react-select";
import ActionButton from "../components/ActionButton";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer } from "react-toastify";
import {
  FetchCreateOrEditStudRegistrationCertificatesServiceRequestthunk,
  FetchGetLoacationNameByLatLangthunk,
  FetchGetServiceDefinitionByIdthunk,
  FetchGetServicesRequestByIdthunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
  resetGetServicesRequestByIdData,
  resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import axios from "../axios/axios";
import axiosMap from "axios";
import SimpleFileUpload from "../components/SimpleFileUpload";
import { base64ToBlob } from "../helper/base64ToBlob";
import EahsForm from "../components/EahsForm";
import MapWithSearchAndLocate from "../components/PickAPlace";
import { eFormButtonsContainer, eformCheckBox, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import SubmitAndPay from "../components/servicesButtons/SubmitAndPay";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";

export default function RequestForRegistrationOfAnArabianHorseStud({ toast }) {
  //env 
  const UMBRACOURL = process.env.REACT_APP_UMBRACO;
  // const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
  const BaseURL = process.env.REACT_APP_BASE_URL;

  //selector
  const { currentLanguage } = useSelector((state) => state.studBookSlice);

  const {
    toasterMessageServicesRequests,
    servicesRequestsLoading,
    getServicesRequestByIdData,
    getServiceDefinitionByIdData,
    createOrEditStudRegistrationCertificatesServiceRequestData,
    getLoacationNameByLatLangData
  } = useSelector((state) => state.servicesRequestsSlice);

  const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
  const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

  const dispatch = useDispatch();

  const { translate } = useTranslate();

  const navigate = useNavigate();

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const serviceId = searchParams.has("serviceId")
    ? searchParams.get("serviceId")
    : null;

  const id = searchParams.has("id") ? searchParams.get("id") : null;

  const action = searchParams.has("action") ? searchParams.get("action") : null;
  const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;

  //state
  const [formModel, setFormModel] = useState({
    id: "",
    studRegistrationId: "",
    eventName: "",
    comment: "",
    referenceNumber: "",
    requestsType: "",
    paymentStatus: "",

    studName: "",
    studNameAr: "",
    emirateId: "",
    emirateDrop: {
      label: translate("web.emirate", "Emirate"),
      value: null,
    },
    regionId: "",
    regionDrop: {
      label: translate("web.area", "Area"),
      value: null,
    },
    studAddress: "",
    studPhone: "",
    latitude: "23.55344",
    longitude: "53.56701",
    lockey: Math.floor(Math.random() * 10000 + 1000),

    isShowCategory: false,
    isRaceCategory: false,
    isEnduranceCategory: false,
    isOtherCategory: false,
    Stud: false,
    Stable: false,
    Racing: false,
    gpsLocationLink: "",
    stableNumber: "",
    groomTrainerNumber: "",
    nearestLandmark: "",
    ownerComment: "",

    stableName: "",
    stableNameAr: "",
    racingName: "",
    racingNameAr: "",

    filePathLandOwnership: "",
    fileTypeLandOwnership: "",
    fileNameLandOwnership: "",
    fileUrlLandOwnership: "",
    landOwnershipAttachmentFile: null,

    filePathLandOwnerAttorney: "",
    fileTypeLandOwnerAttorney: "",
    fileNameLandOwnerAttorney: "",
    fileUrlLandOwnerAttorney: "",
    landOwnerAttorneyAttachmentFile: null,
  });

  const [selectedLocation, setSelectedLocation] = useState({
    // lat: 24.4539, // Latitude of Abu Dhabi
    // lng: 54.3773,
    lat: "", // Latitude of Abu Dhabi
    lng: "",
    //fullAddress: "",
  });

  const [fullAddress, setFullAddress] = useState("")
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
  const [isGroomTrainerPhoneNumberValid, setIsGroomTrainerPhoneNumberValid] = useState(true);
  const [isStablePhoneNumberValid, setIsStablePhoneNumberValid] = useState(true);

  const [
    landOwnershipAttachmentFile,
    setLandOwnershipAttachmentFile,
  ] = useState([]);

  const [
    landOwnerAttorneyAttachmentFile,
    setLandOwnerAttorneyAttachmentFile,
  ] = useState([]);

  const _isOnlinePayment = useRef("");
  const _status = useRef("");

  const [checkedItems, setCheckedItems] = useState({});

  // const [checkedItems, setCheckedItems] = useState({
  //   option1: false,
  //   option2: false,
  //   option3: false,
  //   option4: false,
  //   option5: false,
  //   option6: false,
  //   option7: false,
  //   option8: false,
  //   option9: false,
  //   option10: false,
  //   option11: false,
  //   option12: false,
  // });

  const [profile, setProfile] = useState({
    label:
      !!userProfile &&
      userProfile?.ownerRegisterNo +
      " - " +
      userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
    value: localStorage.getItem("EAHSUserID"),
  });
  const subAccountId = localStorage.getItem("currentSubAccountId");

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 50,
      minHeight: 50,
    }),
  };

  const [latitude, setLatitude] = useState(23.55344);
  const [longitude, setLongitude] = useState(53.56701);
  const [lockey] = useState(Math.floor(Math.random() * 10000 + 1000));

  const [errorStudName, setErrorStudName] = useState("none");
  const [errorStudNameAr, setErrorStudNameAr] = useState("none");
  const [errorEmirateId, setErrorEmirateId] = useState("none");
  const [errorRegionId, setErrorRegionId] = useState("none");
  const [errorStudAddress, setErrorStudAddress] = useState("none");
  const [errorStudPhone, setErrorStudPhone] = useState("none");
  const [errorHorseCategory, setErrorHorseCategory] = useState("none");
  const [errorCategoryStud, setErrorCategoryStud] = useState("none");
  const [errorStableName, setErrorStableName] = useState("none");
  const [errorStableNameAr, setErrorStableNameAr] = useState("none");
  const [errorRacingName, setErrorRacingName] = useState("none");
  const [errorRacingNameAr, setErrorRacingNameAr] = useState("none");
  const [errorGpsLocationLink, setErrorGpsLocationLink] = useState("none");
  const [errorStableNumber, setErrorStableNumber] = useState("none");
  const [errorGroomTrainerNumber, setErrorGroomTrainerNumber] = useState("none");
  const [errorNearestLandmark, setErrorNearestLandmark] = useState("none");
  //const [showHideMap, setShowHideMap] = useState(false);
  const [emiratelistoptions, setEmirateListOptions] = useState([]);
  const [regionsList, setRegionsList] = useState([]);
  const [errorLandOwnership, setErrorLandOwnership] = useState(false);

  //use ref
  const studNameRef = useRef(null);
  const studNameArRef = useRef(null);
  const stableNameRef = useRef(null);
  const stableNameArRef = useRef(null);
  const racingNameRef = useRef(null);
  const racingNameArRef = useRef(null);
  const emirateIdRef = useRef(null);
  const regionIdRef = useRef(null);
  const studAddressRef = useRef(null);
  const studPhoneRef = useRef(null);
  const horseCategoryRef = useRef(null);
  const gpsLocationLinkRef = useRef(null);
  const stableNumberRef = useRef(null);
  const groomTrainerNumberRef = useRef(null);
  const nearestLandmarkRef = useRef(null);
  const landOwnershipRef = useRef(null);

  //function
  async function getEmirateList() {
    try {
      const emiratelist = await axios.get('/lookup/getmaincities')

      const formattedData = await emiratelist.data.result.map((item) => ({
        text: item.name,
        value: item.id,
      }));

      setEmirateListOptions(formattedData)
    } catch (error) {
      toast.error(translate("web.errorFetchingEmirateList", "Error fetching emirate list"));
    }
  }

  async function getRegionListbyID(id) {
    try {
      const regionList = await axios.get(`/lookup/getareasbyemirateid?EmirateId=${id}`)
      const formattedData = await regionList.data.result.map((item) => ({
        text: item.name,
        value: item.id,
      }));
      setRegionsList(formattedData)
    } catch (error) {
      toast.error(translate("web.errorFetchingAreaList", "Error fetching area list"));
    }
  }

  // const toggleMap = () => {
  //   setShowHideMap((prev) => !prev);
  // };

  const selectLocation = async () => {
    try {
      const response = await axiosMap.get(
        `https://maps.atlasapps.net/map.aspx?getLocationString=${lockey}`
      );

      if (!response.data) {
        toast.error(translate("web.pleaseMoveLocationMap", "Please move the location on the map."));
      } else {
        const [lat, lng] = response.data.split(',');

        let params = {
          latVal: lat,
          longVal: lng
        };

        dispatch(FetchGetLoacationNameByLatLangthunk(params));

        setLatitude(lat);
        setLongitude(lng);

        setFormModel({
          ...formModel,
          latitude: lat,
          longitude: lng,
          gpsLocationLink: `https://www.google.com/maps?q=${lat},${lng}`,
          studAddress: getLoacationNameByLatLangData
        });

        toast.success(translate("web.locationSuccessfullyLocated", "Location successfully located."));
      }
    } catch (error) {
      toast.error(translate("web.errorFetchingLocationData", "Error fetching location data."));
    }
  };

  const handleFormChange = (e, input) => {
    if (!!input && input === "emirateId") {
      getRegionListbyID(e.value);

      setFormModel({
        ...formModel,
        emirateId: e.value,
        emirateDrop: e,
        regionId: "",
        regionDrop: {
          label: translate("web.area", "Area"),
          value: null,
        }
      });
    } else if (!!input && input === "regionId") {
      setFormModel({
        ...formModel,
        regionId: e.value,
        regionDrop: e,
      });
    }
    else if (input === "horseCategory") {
      const { name, checked } = e.target;
      let updatedFields = { [name]: checked };

      if (!checked) {
        if (name === "Stud") {
          updatedFields.studName = "";
          updatedFields.studNameAr = "";
        } else if (name === "Stable") {
          updatedFields.stableName = "";
          updatedFields.stableNameAr = "";
        } else if (name === "Racing") {
          updatedFields.racingName = "";
          updatedFields.racingNameAr = "";
        }
      }

      setFormModel({
        ...formModel,
        ...updatedFields,
      });
    }
    else if (input === "studAddress") {
      setFullAddress(e.target.value);
    }
    else if (!!input && (input === "studName" || input === "stableName" || input === "racingName")) {
      const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;
      if (regex.test(e.target.value)) {
        setFormModel({
          ...formModel,
          [input]: e.target.value.toUpperCase(),
        });
      }
    } else if (!!input && (input === "studNameAr" || input === "stableNameAr" || input === "racingNameAr")) {
      const regex = /^[^a-zA-Z]*$/;

      if (regex.test(e.target.value)) {
        setFormModel({
          ...formModel,
          [input]: e.target.value,
        });
      }
    }
    else if (!!input && input === "stableNumber") {
      const val = e.target.value.replace(/[٠-٩]/g, d => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
      if (/^[0-9]*$/.test(val)) {
        setFormModel({
          ...formModel,
          stableNumber: val,
        });
      }
    }
    else if (input === "studPhone") {
      setFormModel({
        ...formModel,
        studPhone: e,
      });
    }
    else {
      setFormModel({
        ...formModel,
        [e.target.name]: e.target.value,
      });
    }

  };

  const handleUploadLandOwnershipChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
      } else {
        setFormModel({
          ...formModel,
          landOwnershipAttachmentFile: e.target.files[0],
        });

        setLandOwnershipAttachmentFile([
          {
            file: e.target.files[0],
            name: e.target.files[0].name,
          },
        ]);
      }
    }
  };

  const handleUploadLandOwnerAttorneyChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size > 10 * 1024 * 1024) {
        toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
      } else {
        setFormModel({
          ...formModel,
          landOwnerAttorneyAttachmentFile: e.target.files[0],
        });

        setLandOwnerAttorneyAttachmentFile([
          {
            file: e.target.files[0],
            name: e.target.files[0].name,
          },
        ]);
      }
    }
  };

  const validInputs = () => {
    let valid = true;

    if (formModel.Stud) {
      if (formModel.studName === "") {
        setErrorStudName("");
        valid = false;
        studNameRef?.current?.focus();
        return;
      } else {
        setErrorStudName("none");
      }

      if (formModel.studNameAr === "") {
        setErrorStudNameAr("");
        valid = false;
        studNameArRef?.current?.focus();
        return;
      } else {
        setErrorStudNameAr("none");
      }
    }

    if (formModel.Stable) {
      if (formModel.stableName === "") {
        setErrorStableName("");
        valid = false;
        stableNameRef?.current?.focus();
        return;
      } else {
        setErrorStableName("none");
      }

      if (formModel.stableNameAr === "") {
        setErrorStableNameAr("");
        valid = false;
        stableNameArRef?.current?.focus();
        return;
      } else {
        setErrorStableNameAr("none");
      }
    }

    if (formModel.Racing) {
      if (formModel.racingName === "") {
        setErrorRacingName("");
        valid = false;
        racingNameRef?.current?.focus();
        return;
      } else {
        setErrorRacingName("none");
      }

      if (formModel.racingNameAr === "") {
        setErrorRacingNameAr("");
        valid = false;
        racingNameArRef?.current?.focus();
        return;
      } else {
        setErrorRacingNameAr("none");
      }
    }

    if (
      formModel.studPhone === ""
    ) {
      setErrorStudPhone("");
      valid = false;

      studPhoneRef?.current?.focus();
      return;
    }
    else {
      setErrorStudPhone("none");
    }

    if (
      formModel.isShowCategory === false && formModel.isRaceCategory === false && formModel.isEnduranceCategory === false && formModel.isOtherCategory === false
    ) {
      setErrorHorseCategory("");
      valid = false;

      //horseCategoryRef?.current?.focus();
      //return;
    }
    else {
      setErrorHorseCategory("none");
    }

    if (
      formModel.Stud === false && formModel.Stable === false && formModel.Racing === false
    ) {
      setErrorCategoryStud("");
      valid = false;
    }
    else {
      setErrorCategoryStud("none");
    }

    if (
      formModel.emirateId === ""
    ) {
      setErrorEmirateId("");
      valid = false;

      emirateIdRef?.current?.focus();
      return;
    }
    else {
      setErrorEmirateId("none");
    }

    if (
      formModel.regionId === ""
    ) {
      setErrorRegionId("");
      valid = false;

      regionIdRef?.current?.focus();
      return;
    }
    else {
      setErrorRegionId("none");
    }

    if (
      // formModel.studAddress === ""
      fullAddress.trim() === ""
    ) {
      setErrorStudAddress("");
      valid = false;

      studAddressRef?.current?.focus();
      return;
    }
    else {
      setErrorStudAddress("none");
    }

    if (
      selectedLocation.lat === "" && selectedLocation.lng === ""
      // formModel.gpsLocationLink === ""
    ) {
      setErrorGpsLocationLink("");
      valid = false;

      // gpsLocationLinkRef?.current?.focus();

      var _mapLocationRef = gpsLocationLinkRef?.current;
      _mapLocationRef.disabled = false;

      _mapLocationRef.focus();

      _mapLocationRef.disabled = true;
      return;
    }
    else {
      setErrorGpsLocationLink("none");
    }

    if (
      formModel.stableNumber === "" || formModel.stableNumber == null
    ) {
      setErrorStableNumber("");
      valid = false;
      stableNumberRef?.current?.focus();
      return;
    }
    else {
      setErrorStableNumber("none");
    }

    if (
      formModel.groomTrainerNumber === "" || formModel.groomTrainerNumber == null || !isGroomTrainerPhoneNumberValid
    ) {
      setErrorGroomTrainerNumber("");
      valid = false;
      groomTrainerNumberRef?.current?.focus();
      return;
    }
    else {
      setErrorGroomTrainerNumber("none");
    }

    if (
      formModel.nearestLandmark === "" || formModel.nearestLandmark == null
    ) {
      setErrorNearestLandmark("");
      valid = false;
      nearestLandmarkRef?.current?.focus();
      return;
    }
    else {
      setErrorNearestLandmark("none");
    }

    if (formModel.fileUrlLandOwnership === ""
      && landOwnershipAttachmentFile.length === 0
    ) {
      setErrorLandOwnership(true);
      valid = false;
      landOwnershipRef?.current?.focus();
      return;
    }
    else {
      setErrorLandOwnership(false);
    }

    //terms
    if (Object.values(checkedItems).length > 0) {  // Optional safe check
      const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

      if (!allTermsChecked && action == null) {
        toast.error(
          translate("web.pleaseCheckAllTerms", "Please Check All Terms")
        );
        valid = false;
      }
    }

    // if (
    //   !checkedItems.option1
    //   || !checkedItems.option2
    //   || !checkedItems.option3
    //   || !checkedItems.option4
    //   || !checkedItems.option5
    //   || !checkedItems.option6
    //   || !checkedItems.option7
    //   || !checkedItems.option8
    //   || !checkedItems.option9
    //   || !checkedItems.option10
    //   || !checkedItems.option11
    //   || !checkedItems.option12
    // ) {
    //   toast.error(
    //     translate("web.pleaseCheckAllTerms", "Please Check All Terms")
    //   );
    //   valid = false;
    // }

    return valid;
  }

  const handelFormSubmit = (status, isOnlinePayment, buttonAction = 'Draft') => {
    if (formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice" && formModel.eventName !== "SentBack") {
      const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${id}`;

      const encodeURI = encodeURIComponent(returnUrl);

      window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=14&userId=${localStorage.getItem("EAHSUserID")}&returnUrl=${encodeURI}&isOnline=${isOnlinePayment}&lang=${currentLanguage}`;
    }
    else {
      if (
        validInputs()
      ) {
        _isOnlinePayment.current = isOnlinePayment;
        _status.current = status;

        let params = {
          id: id == null ? '' : id,
          studRegistrationId: formModel.studRegistrationId,
          ownerId: getUserID(),
          studName: formModel.studName,
          studNameAr: formModel.studNameAr,
          stableName: formModel.stableName,
          stableNameAr: formModel.stableNameAr,
          racingName: formModel.racingName,
          racingNameAr: formModel.racingNameAr,
          emirateId: formModel.emirateId,
          regionId: formModel.regionId,
          studAddress: fullAddress, //formModel.studAddress,
          studPhone: formModel.studPhone,
          isShowCategory: formModel.isShowCategory,
          isRaceCategory: formModel.isRaceCategory,
          isEnduranceCategory: formModel.isEnduranceCategory,
          isOtherCategory: formModel.isOtherCategory,
          Stud: formModel.Stud,
          Stable: formModel.Stable,
          Racing: formModel.Racing,
          gpsLocationLink: formModel.gpsLocationLink,
          latitude: selectedLocation.lat,//latitude,
          longitude: selectedLocation.lng, //longitude,
          stableNumber: formModel.stableNumber,
          groomTrainerNumber: formModel.groomTrainerNumber,
          nearestLandmark: formModel.nearestLandmark,
          status: status,
          ownerComment: formModel.ownerComment,
          landOwnershipAttachmentFile: formModel.landOwnershipAttachmentFile,
          landOwnerAttorneyAttachmentFile: formModel.landOwnerAttorneyAttachmentFile,
          buttonAction: buttonAction
        };

        dispatch(FetchCreateOrEditStudRegistrationCertificatesServiceRequestthunk(params));
      }
      else {
        toast.error(
          translate("web.completeTheRequiredData", "Complete The Required Data")
        );
      }
    }
  };

  const handelSelectedAccountChange = async (element) => {
    setProfile(element);
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setCheckedItems((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  function CheckIfAgentHasPermission() {
    const AgentHasPermission = userProfile.subAccounts
      .filter((x) => x.value == subAccountId)[0]
      .ownersPermissionsList.some(
        (x) =>
          x.permissionName === "StudRegistration" || x.permissionName === "All"
      );
    return AgentHasPermission;
  }

  // const getUserID = () => {
  //   const userID =
  //     !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
  //   return userID;
  // };
  const getUserID = () => {
    let userID =
      !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
    if ((action == null || action === "edit") == false) {
      userID = subAccountId;
    }
    return userID;
  };
  const getSelectedAccountName = () => {
    const selectAccount = userProfile.subAccounts.filter(
      (x) => x.value == subAccountId
    );

    if (selectAccount.length > 0) {
      return selectAccount[0];
    }
    else {
      return false;
    }
  };

  const dismissAll = () => toast.dismiss();

  //Effect
  useEffect(() => {
    if (id != null) {
      let params = {
        language: currentLanguage,
        id: id,
        ownerId: ownerId,
      };

      dispatch(FetchGetServicesRequestByIdthunk(params));
    }

    return () => {
      dispatch(resetGetServicesRequestByIdData());
    };
  }, []);

  useEffect(() => {
    if (!!userProfile && (userProfile?.haveProfileSignture != true || userProfile?.isStud)) {

      if (!!userProfile && userProfile?.haveProfileSignture != true) {
        toast.error(
          translate(
            "web.completeOwnerProfileData",
            "Please complete the personal data of the profile."
          )
        );
      }

      else if (!!userProfile && userProfile?.isStud) {
        toast.error(
          translate(
            "web.youCantCreateThisServiceBecuseYourStudAccount",
            "you Can't Create This Service Because Your Stud Account"
          )
        );
      }

      setTimeout(() => {
        navigate("/profile");
      }, 3000);
    }

    if (!!userProfile && userProfile?.accountType === "Agent") {
      if (userProfile.id == subAccountId) {
        navigate("/403-Not-Authrized");
      }

      if (!CheckIfAgentHasPermission()) {
        navigate("/403-Not-Authrized");
      }
    }

    getEmirateList();

    let subOwnerProfilesParams = {
      id: getUserID(),
      langauge: currentLanguage,
    };
    dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));

    dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));
  }, [currentLanguage]);

  useEffect(() => {
    if (getServicesRequestByIdData != null &&
      Object.keys(getServicesRequestByIdData).length > 0 && (getServicesRequestByIdData.serviceDefinitionId == serviceId)
    ) {
      setFormModel({
        ...formModel,
        eventName: getServicesRequestByIdData.eventName,
        comment: getServicesRequestByIdData.comment,
        requestsType: getServicesRequestByIdData.requestsType,
        paymentStatus: getServicesRequestByIdData.paymentStatus,
        referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,
        studRegistrationId: getServicesRequestByIdData.studRegistrationDto.id,
        studName: getServicesRequestByIdData.studRegistrationDto.studName,
        studNameAr: getServicesRequestByIdData.studRegistrationDto.studNameAr,
        stableName: getServicesRequestByIdData.studRegistrationDto.stableName,
        stableNameAr: getServicesRequestByIdData.studRegistrationDto.stableNameAr,
        racingName: getServicesRequestByIdData.studRegistrationDto.racingName,
        racingNameAr: getServicesRequestByIdData.studRegistrationDto.racingNameAr,
        emirateId: getServicesRequestByIdData.studRegistrationDto.emirateId,
        emirateDrop: {
          label: getServicesRequestByIdData.studRegistrationDto.emirateName,
          value: getServicesRequestByIdData.studRegistrationDto.emirateId,
        },
        regionId: getServicesRequestByIdData.studRegistrationDto.regionId,
        regionDrop: {
          label: getServicesRequestByIdData.studRegistrationDto.regionName,
          value: getServicesRequestByIdData.studRegistrationDto.regionId,
        },
        studAddress: getServicesRequestByIdData.studRegistrationDto.studAddress,
        studPhone: getServicesRequestByIdData.studRegistrationDto.studPhone,
        latitude: getServicesRequestByIdData.studRegistrationDto.latitude,
        longitude: getServicesRequestByIdData.studRegistrationDto.longitude,
        isShowCategory: getServicesRequestByIdData.studRegistrationDto.isShowCategory,
        isRaceCategory: getServicesRequestByIdData.studRegistrationDto.isRaceCategory,
        isEnduranceCategory: getServicesRequestByIdData.studRegistrationDto.isEnduranceCategory,
        isOtherCategory: getServicesRequestByIdData.studRegistrationDto.isOtherCategory,
        Stud: getServicesRequestByIdData.studRegistrationDto.stud ?? getServicesRequestByIdData.studRegistrationDto.Stud ?? false,
        Stable: getServicesRequestByIdData.studRegistrationDto.stable ?? getServicesRequestByIdData.studRegistrationDto.Stable ?? false,
        Racing: getServicesRequestByIdData.studRegistrationDto.racing ?? getServicesRequestByIdData.studRegistrationDto.Racing ?? false,
        gpsLocationLink: getServicesRequestByIdData.studRegistrationDto.gpsLocationLink,
        stableNumber: getServicesRequestByIdData.studRegistrationDto.stableNumber || "",
        groomTrainerNumber: getServicesRequestByIdData.studRegistrationDto.groomTrainerNumber || "",
        nearestLandmark: getServicesRequestByIdData.studRegistrationDto.nearestLandmark || "",
        ownerComment: getServicesRequestByIdData.studRegistrationDto.ownerComment != null ? getServicesRequestByIdData.studRegistrationDto.ownerComment : "",

        filePathLandOwnership: getServicesRequestByIdData.studRegistrationDto.landOwnershipAttachmentFile.filePath,
        fileTypeLandOwnership: getServicesRequestByIdData.studRegistrationDto.landOwnershipAttachmentFile.fileType,
        fileNameLandOwnership: getServicesRequestByIdData.studRegistrationDto.landOwnershipAttachmentFile.fileName,
        fileUrlLandOwnership: getServicesRequestByIdData.studRegistrationDto.landOwnershipAttachmentFile.fileUrl,

        filePathLandOwnerAttorney: getServicesRequestByIdData.studRegistrationDto.landOwnerAttorneyAttachmentFile.filePath,
        fileTypeLandOwnerAttorney: getServicesRequestByIdData.studRegistrationDto.landOwnerAttorneyAttachmentFile.fileType,
        fileNameLandOwnerAttorney: getServicesRequestByIdData.studRegistrationDto.landOwnerAttorneyAttachmentFile.fileName,
        fileUrlLandOwnerAttorney: getServicesRequestByIdData.studRegistrationDto.landOwnerAttorneyAttachmentFile.fileUrl,
      });

      if (getServicesRequestByIdData.studRegistrationDto.emirateId) {
        getRegionListbyID(getServicesRequestByIdData.studRegistrationDto.emirateId);
      }

      //setLatitude(getServicesRequestByIdData.studRegistrationDto.latitude);
      //setLongitude(getServicesRequestByIdData.studRegistrationDto.longitude);

      setSelectedLocation({
        lat: Number(getServicesRequestByIdData.studRegistrationDto.latitude),
        lng: Number(getServicesRequestByIdData.studRegistrationDto.longitude),
        fullAddress: getServicesRequestByIdData.studRegistrationDto.studAddress,
      })

      setFullAddress(getServicesRequestByIdData.studRegistrationDto.studAddress)

      //another owner
      if (
        getServicesRequestByIdData.studRegistrationDto.ownerId !==
        getServicesRequestByIdData.studRegistrationDto.createdBy &&
        subOwnerProfilesByIdData.length > 0 &&
        getServicesRequestByIdData.requestsType !== "BackOffice"
      ) {
        //update profile
        setProfile({
          label:
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.studRegistrationDto.ownerId
            )[0].registerNo +
            " - " +
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.studRegistrationDto.ownerId
            )[0][`text${currentLanguage === "en" ? "" : "Ar"}`],
          value: subOwnerProfilesByIdData.filter(
            (item) =>
              item.value == getServicesRequestByIdData.studRegistrationDto.ownerId
          )[0].value,
        });
      }

      //options
      // setCheckedItems({
      //   option1: true,
      //   option2: true,
      //   option3: true,
      //   option4: true,
      //   option5: true,
      //   option6: true,
      //   option7: true,
      //   option8: true,
      //   option9: true,
      //   option10: true,
      //   option11: true,
      //   option12: true,
      // });
    }
  }, [
    getServicesRequestByIdData,
  ]);

  useEffect(() => {
    if (
      toasterMessageServicesRequests != null &&
      toasterMessageServicesRequests === "save"
    ) {
      if (_isOnlinePayment.current !== "") {
        toast.success(
          translate(
            "web.yourRequestHasSubmittedSuccessfully",
            "Your Request Has Submitted Successfully"
          )
        );
      } else {
        toast.success(
          translate("web.dataSavedSuccessfully", "Data Saved Successfully")
        );
      }

      dispatch(resetToasterMessageServicesRequests());

      setTimeout(() => {
        if (_isOnlinePayment.current !== "") {
          const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${createOrEditStudRegistrationCertificatesServiceRequestData.id}`;

          const encodeURI = encodeURIComponent(returnUrl);

          window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${createOrEditStudRegistrationCertificatesServiceRequestData.id}&paymentType=14&userId=${localStorage.getItem(
            "EAHSUserID"
          )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
        } else {
          if (_status.current === "Submit" && formModel.eventName !== "SentBack") {
            navigate(`/profile?activeTab=${"e_services"}&serviceId=${createOrEditStudRegistrationCertificatesServiceRequestData.id}`);
          }
          else {
            navigate(`/profile?activeTab=${"e_services"}`);
          }
        }
      }, 1000);
    }

    //error
    else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
      if (toasterMessageServicesRequests !== "errorServiceDetails") {

        toast.error(
          translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
        );

        dispatch(resetToasterMessageServicesRequests());
      }

      else if (toasterMessageServicesRequests === "errorServiceDetails") {
        toast.error(
          translate("web.createServiceRequestFailed", "Service Request Failed")
        );

        dispatch(resetToasterMessageServicesRequests());

        setTimeout(() => {
          navigate(`/profile?activeTab=${"e_services"}`);
        }, 1000);
      }
    }
  }, [toasterMessageServicesRequests]);

  useEffect(() => {
    if (getServiceDefinitionByIdData?.termsList) {
      const initialState = {};
      getServiceDefinitionByIdData.termsList.forEach((_, index) => {
        initialState[`option${index + 1}`] = false;
      });
      setCheckedItems(initialState);
    }
  }, [getServiceDefinitionByIdData?.termsList]);

  //consoles
  console.log(formModel)
  console.log(selectedLocation)

  return (
    <>
      {
        // loading div
      }
      <div
        className={`page-overlay text-center ${servicesRequestsLoading
          ? "classdisplay"
          : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>
      {/* toast */}
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />
      {
        //content page
      }
      <div className={serviceRequestHeadContainer}>
        {
          //owned Registered Horse Certificate title
        }
        <h2 className={serviceRequestTitle}>
          {currentLanguage === "en"
            ? getServiceDefinitionByIdData.nameEn
            : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
        </h2>
        {
          // Selected Account
        }
        {subOwnerProfilesByIdData.length > 0 &&
          (action == null || action === "edit") &&
          (
            <div className={userDropDown}>
              {!!userProfile && userProfile?.accountType !== "Agent" ? (
                <>
                  <NetaqInput
                    label={translate("web.selectedAccount", "Selected Account")}
                    name="selectAccount"
                    type="select"
                    listSelect={[

                      ...(!!subOwnerProfilesByIdData &&
                        !!subOwnerProfilesByIdData.length > 0 &&
                        subOwnerProfilesByIdData.map((a) => ({
                          label:
                            (a?.registerNo ?? "") +
                            " - " +
                            a[`text${currentLanguage === "en" ? "" : "Ar"}`],
                          value: a.value,
                        }))),
                    ]}
                    value={profile}
                    onChange={(e) => {
                      handelSelectedAccountChange(e);
                    }}
                    placeholder={localStorage.getItem("EAHSUserFullName")}
                  />
                </>
              ) : (
                <label className="capatalize_text">
                  {getSelectedAccountName()?.registerNo +
                    " - " +
                    getSelectedAccountName()[
                    `text${currentLanguage === "en" ? "" : "Ar"}`
                    ]}
                </label>
              )}
            </div>
          )}
      </div>
      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.studDetails", "Stud Details")}>
        <label className="mt">
          {translate("web.studCategory", "Category")}
          <i className=" colorred"> *</i>
        </label>
        <div className="row mx-0">
          <div className={eformCheckBox}>
            <NetaqInput
              type={"checkbox"}
              label={translate("web.isStud", "Stud")}
              name="Stud"
              checked={formModel.Stud}
              onChange={(e) => handleFormChange(e, "horseCategory")}
              disabled={
                ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ? true : false
              }
            />
          </div>
          <div className={eformCheckBox}>
            <NetaqInput
              type={"checkbox"}
              label={translate("web.isStable", "Stable")}
              name="Stable"
              checked={formModel.Stable}
              onChange={(e) => handleFormChange(e, "horseCategory")}
              disabled={
                ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ? true : false
              }
            />
          </div>
          <div className={eformCheckBox}>
            <NetaqInput
              type={"checkbox"}
              label={translate("web.racing", "Racing")}
              name="Racing"
              checked={formModel.Racing}
              onChange={(e) => handleFormChange(e, "horseCategory")}
              disabled={
                ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ? true : false
              }
            />
          </div>
          <span style={{ color: "red", display: errorCategoryStud }}>
            {translate("web.requiredField", "Required Field")}
          </span>
        </div>

        {formModel.Stud && (
          <>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.studName", "Stud Name") + " (EN)"}
                name={"studName"}
                type={"text"}
                onChange={(e) => handleFormChange(e, "studName")}
                value={formModel.studName}
                required={true}
                disabled={
                  ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                    true
                    : false
                }
                ref={studNameRef}
              />
              <p style={{ color: "red", display: errorStudName }}>
                {translate("web.requiredField", "Required Field")}
              </p>
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.studName", "Name") + " (AR)"}
                name={"studNameAr"}
                type={"text"}
                onChange={(e) => handleFormChange(e, "studNameAr")}
                value={formModel.studNameAr}
                required={true}
                disabled={
                  ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                    true
                    : false
                }
                ref={studNameArRef}
              />
              <p style={{ color: "red", display: errorStudNameAr }}>
                {translate("web.requiredField", "Required Field")}
              </p>
            </div>
          </>
        )}

        {formModel.Stable && (
          <>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.stableName", "Stable Name") + " (EN)"}
                name={"stableName"}
                type={"text"}
                onChange={(e) => handleFormChange(e, "stableName")}
                value={formModel.stableName}
                required={true}
                disabled={
                  ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                    true
                    : false
                }
                ref={stableNameRef}
              />
              <p style={{ color: "red", display: errorStableName }}>
                {translate("web.requiredField", "Required Field")}
              </p>
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.stableName", "Stable Name") + " (AR)"}
                name={"stableNameAr"}
                type={"text"}
                onChange={(e) => handleFormChange(e, "stableNameAr")}
                value={formModel.stableNameAr}
                required={true}
                disabled={
                  ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                    true
                    : false
                }
                ref={stableNameArRef}
              />
              <p style={{ color: "red", display: errorStableNameAr }}>
                {translate("web.requiredField", "Required Field")}
              </p>
            </div>
          </>
        )}

        {formModel.Racing && (
          <>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.nameRacing", "Racing Name") + " (EN)"}
                name={"racingName"}
                type={"text"}
                onChange={(e) => handleFormChange(e, "racingName")}
                value={formModel.racingName}
                required={true}
                disabled={
                  ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                    true
                    : false
                }
                ref={racingNameRef}
              />
              <p style={{ color: "red", display: errorRacingName }}>
                {translate("web.requiredField", "Required Field")}
              </p>
            </div>
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.nameRacing", "Racing Name") + " (AR)"}
                name={"racingNameAr"}
                type={"text"}
                onChange={(e) => handleFormChange(e, "racingNameAr")}
                value={formModel.racingNameAr}
                required={true}
                disabled={
                  ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                    true
                    : false
                }
                ref={racingNameArRef}
              />
              <p style={{ color: "red", display: errorRacingNameAr }}>
                {translate("web.requiredField", "Required Field")}
              </p>
            </div>
          </>
        )}
        <div className={eformInput}>
          <NetaqInput
            type={'phone'}
            value={formModel.studPhone}
            label={translate("web.smsPhoneNo", "Mobile No")}
            name={'studPhone'}
            placeholder={'971xxxxxxxxx'}
            required={true}
            onChange={(e) => handleFormChange(e, "studPhone")}
            setIsPhoneNumberValid={setIsPhoneNumberValid}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={studPhoneRef}
          />
          {!isPhoneNumberValid &&
            <div className='text-danger'>
              {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
            </div>
          }
          <p style={{ color: "red", display: errorStudPhone }}>
            {translate("web.requiredField", "Required Field")}
          </p>
        </div>
        {/* <div className={eformInput}>      
          <NetaqInput
            label={translate("web.phone", "Phone")}
            name={"studPhone"}
            type={"text"}
            onChange={handleFormChange}
            value={formModel.studPhone}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={studPhoneRef}
          />
          <p style={{ color: "red", display: errorStudPhone }}>
            {translate("web.requiredField", "Required Field")}
          </p>
        </div> */}
        <label>
          {translate("web.horseCategoryDetails", "Horse Category Details")}
          <i className=" colorred"> *</i>
        </label>
        <div className="row mx-0">
          <div className={eformCheckBox}>
            <NetaqInput
              type={"checkbox"}
              label={translate(
                "web.isShowCategory",
                "Is Show Category"
              )}
              name="isShowCategory"
              checked={formModel.isShowCategory}
              onChange={(e) => handleFormChange(e, "horseCategory")}
              disabled={
                ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                  true
                  : false
              }
            />
          </div>
          <div className={eformCheckBox}>
            <NetaqInput
              type={"checkbox"}
              label={translate(
                "web.isRaceCategory",
                "Is Race Category"
              )}
              name="isRaceCategory"
              checked={formModel.isRaceCategory}
              onChange={(e) => handleFormChange(e, "horseCategory")}
              disabled={
                ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                  true
                  : false
              }
            />
          </div>
          <div className={eformCheckBox}>
            <NetaqInput
              type={"checkbox"}
              label={translate(
                "web.isEnduranceCategory",
                "Is Endurance Category"
              )}
              name="isEnduranceCategory"
              checked={formModel.isEnduranceCategory}
              onChange={(e) => handleFormChange(e, "horseCategory")}
              disabled={
                ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                  true
                  : false
              }
            />
          </div>
          <div className={eformCheckBox}>
            <NetaqInput
              type={"checkbox"}
              label={translate(
                "web.isOtherCategory",
                "Is Other Category"
              )}
              name="isOtherCategory"
              checked={formModel.isOtherCategory}
              onChange={(e) => handleFormChange(e, "horseCategory")}
              disabled={
                ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                  true
                  : false
              }
            />
          </div>
          <span style={{ color: "red", display: errorHorseCategory }}>
            {translate("web.requiredField", "Required Field")}
          </span>
        </div>


      </EahsForm>

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.studLocationDetails", "Stud Location Details")}>
        <div className={eformInput}>
          <NetaqInput
            type={"select"}
            label={translate("web.emirate", "Emirate")}
            placeholder={translate("web.emirate", "emirate")}
            name={"emirateId"}
            listSelect={emiratelistoptions}
            value={formModel.emirateDrop}
            onChange={(e) => handleFormChange(e, "emirateId")}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={emirateIdRef}
          />
          <span style={{ color: "red", display: errorEmirateId }}>
            {translate("web.requiredField", "Required Field")}
          </span>
        </div>

        <div className={eformInput}>
          <NetaqInput
            type={"select"}
            label={translate("web.area", "Area")}
            placeholder={translate("web.area", "Area")}
            name={"regionId"}
            listSelect={regionsList}
            value={formModel.regionDrop}
            onChange={(evt) => handleFormChange(evt, "regionId")}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={regionIdRef}
          />
          <span style={{ color: "red", display: errorRegionId }}>
            {translate("web.requiredField", "Required Field")}
          </span>
        </div>

        <div className={eformInput}>
          <NetaqInput
            type={'text'}
            value={formModel.stableNumber}
            label={translate("web.stableNumber", "Stable / Stud Number")}
            name={'stableNumber'}
            placeholder={translate("web.stableNumber", "Stable / Stud Number")}
            required={true}
            onChange={(e) => handleFormChange(e, "stableNumber")}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={stableNumberRef}
          />
          <p style={{ color: "red", display: errorStableNumber }}>
            {translate("web.requiredField", "Required Field")}
          </p>
        </div>

        <div className={eformInput}>
          <NetaqInput
            type={'phone'}
            value={formModel.groomTrainerNumber}
            label={translate("web.groomTrainerNumber", "Groom / Trainer Number")}
            name={'groomTrainerNumber'}
            placeholder={'971xxxxxxxxx'}
            required={true}
            onChange={(value) => {
              setFormModel((prev) => ({
                ...prev,
                groomTrainerNumber: value
              }));
            }}
            setIsPhoneNumberValid={setIsGroomTrainerPhoneNumberValid}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={groomTrainerNumberRef}
          />
          {!isGroomTrainerPhoneNumberValid && (
            <div className='text-danger'>
              {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
            </div>
          )}
          <p style={{ color: "red", display: errorGroomTrainerNumber }}>
            {translate("web.requiredField", "Required Field")}
          </p>
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.nearestLandmark", "Nearest Landmark")}
            name={"nearestLandmark"}
            type={"text"}
            placeholder={translate("web.nearestLandmark", "Nearest Landmark")}
            onChange={handleFormChange}
            value={formModel.nearestLandmark}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={nearestLandmarkRef}
          />
          <p style={{ color: "red", display: errorNearestLandmark }}>
            {translate("web.requiredField", "Required Field")}
          </p>
        </div>

        {
          // <div className="col-md-12 col-sm-12 mt-3">
          //       <div className="col-md-3 mt-3">
          //         <ActionButton
          //           className="btn-info text-white w-50"
          //           type={"bootstrapbtn"}
          //           text={`<i class="fa-solid fa-eye fa-lg marginrightleft-10"></i>                   
          //                  ${translate("web.showHideMap", "Show/Hide MAP")}
          //                  `}
          //           margin={"0"}
          //           width={"100%"}
          //           onClick={toggleMap}
          //         />
          //       </div>
          //     </div>
        }

        {//showHideMap && (
          <div className="col-md-12 col-sm-12 mt-3 mb-form-group">
            <MapWithSearchAndLocate
              setSelectedLocation={setSelectedLocation}
              selectedLocation={selectedLocation}
              setFullAddress={setFullAddress}
              fullAddress={fullAddress}
              isView={((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false}
            />

            {/* <iframe
                  id="Imap"
                  src={`https://maps.atlasapps.net/map.aspx?set=yes&location=${latitude},${longitude}&key=${lockey}&MapsKey=AIzaSyB26sBNX-V2SgrBTaWpepPfXvttfiIb2YM`}
                  width="100%"
                  height="350"
                  frameborder="0"
                  style={{ border: 0 }}
                  allowfullscreen=""
                ></iframe>
                <div className="col-md-3 mt-3">
                  <ActionButton
                    className="btn-info text-white w-50"
                    type={"bootstrapbtn"}
                    text={`<i class="fa-solid fa-location-dot fa-lg marginrightleft-10"></i>                   
                             ${translate("web.selectLocation", "Select Location")}
                            `}
                    margin={"0"}
                    width={"100%"}
                    onClick={
                      selectLocation
                    }
                    disabled={
                      ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                        true
                        : false
                    }
                  />
                </div> */}
          </div>
          //)
        }

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.address", "Address")}
            name={"studAddress"}
            type={"text"}
            onChange={(e) => handleFormChange(e, "studAddress")}
            // value={formModel.studAddress}
            value={fullAddress}
            required={true}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={studAddressRef}
          />
          <p style={{ color: "red", display: errorStudAddress }}>
            {translate("web.requiredField", "Required Field")}
          </p>
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.mapLocation", "Map Location")}
            name={"gpsLocationLink"}
            type={"text"}
            onChange={handleFormChange}
            //value={formModel.gpsLocationLink}
            //value={`https://www.google.com/maps?q=${selectedLocation.lat},${selectedLocation.lng}`}
            value={selectedLocation.lat === "" ? "" : `https://www.google.com/maps?q=${selectedLocation.lat},${selectedLocation.lng}`}
            required={true}
            disabled={true}
            ref={gpsLocationLinkRef}
          />
          <p style={{ color: "red", display: errorGpsLocationLink }}>
            {translate("web.requiredField", "Required Field")}
          </p>
        </div>
      </EahsForm>

      {/* <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.horseCategoryDetails", "Horse Category Details")}>
            <div className="col-md-12 col-sm-12 rtl service">
              <NetaqInput
                type={"checkbox"}
                label={translate(
                  "web.isShowCategory",
                  "Is Show Category"
                )}
                name="isShowCategory"
                checked={formModel.isShowCategory}
                onChange={(e) => handleFormChange(e, "horseCategory")}
                disabled={
                  ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                    true
                    : false
                }
              />
            </div>
            <div className="col-md-12 col-sm-12 rtl service">
              <NetaqInput
                type={"checkbox"}
                label={translate(
                  "web.isRaceCategory",
                  "Is Race Category"
                )}
                name="isRaceCategory"
                checked={formModel.isRaceCategory}
                onChange={(e) => handleFormChange(e, "horseCategory")}
                disabled={
                  ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                    true
                    : false
                }
              />
            </div>
            <div className="col-md-12 col-sm-12 rtl service">
              <NetaqInput
                type={"checkbox"}
                label={translate(
                  "web.isEnduranceCategory",
                  "Is Endurance Category"
                )}
                name="isEnduranceCategory"
                checked={formModel.isEnduranceCategory}
                onChange={(e) => handleFormChange(e, "horseCategory")}
                disabled={
                  ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                    true
                    : false
                }
              />
            </div>
            <div className="col-md-12 col-sm-12 rtl service">
              <NetaqInput
                type={"checkbox"}
                label={translate(
                  "web.isOtherCategory",
                  "Is Other Category"
                )}
                name="isOtherCategory"
                checked={formModel.isOtherCategory}
                onChange={(e) => handleFormChange(e, "horseCategory")}
                disabled={
                  ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                    true
                    : false
                }
              />
            </div>
            <span style={{ color: "red", display: errorHorseCategory }}>
              {translate("web.requiredField", "Required Field")}
            </span>
          </EahsForm> */}

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.uploadDocument", "Upload Document")}>
        <div className={eformInput}>
          <label>
            {translate("web.landOwnershipCopy", "Land ownership copy")}
            <i className=" colorred"> *</i>
          </label>
          <SimpleFileUpload
            isMulti={false}
            initialFiles={
              !!formModel.filePathLandOwnership &&
                !!formModel.fileUrlLandOwnership &&
                landOwnershipAttachmentFile.length === 0
                ? [
                  {
                    file: formModel?.fileUrlLandOwnership,
                    name: formModel?.fileNameLandOwnership,
                  },
                ]
                : landOwnershipAttachmentFile
            }
            isServer={
              !!formModel.filePathLandOwnership &&
                !!formModel.fileUrlLandOwnership &&
                landOwnershipAttachmentFile.length === 0
                ? true
                : false
            }
            onChange={handleUploadLandOwnershipChange}
            accept={"image/*,application/pdf"}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={landOwnershipRef}
          />
          {errorLandOwnership && (
            <span style={{ color: "red" }}
            >
              {translate("web.requiredField", "Required Field")}
            </span>
          )}
        </div>
        <div className={eformInput}>
          <label>
            {translate("web.landOwnerAttorney", "Land owner's power of attorney")}
          </label>
          <SimpleFileUpload
            isMulti={false}
            initialFiles={
              !!formModel.filePathLandOwnerAttorney &&
                !!formModel.fileUrlLandOwnerAttorney &&
                landOwnerAttorneyAttachmentFile.length === 0
                ? [
                  {
                    file: formModel?.fileUrlLandOwnerAttorney,
                    name: formModel?.fileNameLandOwnerAttorney,
                  },
                ]
                : landOwnerAttorneyAttachmentFile
            }
            isServer={
              !!formModel.filePathLandOwnerAttorney &&
                !!formModel.fileUrlLandOwnerAttorney &&
                landOwnerAttorneyAttachmentFile.length === 0
                ? true
                : false
            }
            onChange={handleUploadLandOwnerAttorneyChange}
            accept={"image/*,application/pdf"}
            disabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
          />
        </div>
      </EahsForm>

      {/* Comments */}
      {(!!formModel.comment || !!formModel.ownerComment) && (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.comments", "Comments")}>
          {!!formModel.comment && (
            // eahs Comment
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.eahsComments", "EAHS Comments")}
                name={"adminComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.comment}
                disabled={true}
              />
            </div>
          )}

          {(!!formModel.ownerComment || (formModel.eventName === "SentBack" && action !== "view")) && (
            // owner Comment 
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.ownerComment", "Owner Comment")}
                name={"ownerComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.ownerComment}
                onChange={handleFormChange}
                disabled={formModel.eventName === "SentBack" && action !== "view" ? false : true}
              />
            </div>
          )}
        </EahsForm>
      )}

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
          return (
            <div className={eformTerms} key={index}>
              <NetaqInput
                type={"checkbox"}
                label={item}
                name={`option${index + 1}`}
                checked={checkedItems[`option${index + 1}`] || action != null}
                onChange={handleCheckboxChange}
                disabled={formModel.eventName !== ""}
              />
            </div>
          );
        })}
      </EahsForm>

      {/* <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.studTerm1",
              "Stud Term 1"
            )}
            name="option1"
            checked={checkedItems.option1}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.studTerm2",
              "Stud Term 2"
            )}
            name="option2"
            checked={checkedItems.option2}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.studTerm3",
              "Stud Term 3"
            )}
            name="option3"
            checked={checkedItems.option3}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.studTerm4",
              "Stud Term 4"
            )}
            name="option4"
            checked={checkedItems.option4}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.studTerm5",
              "Stud Term 5"
            )}
            name="option5"
            checked={checkedItems.option5}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.studTerm6",
              "Stud Term 6"
            )}
            name="option6"
            checked={checkedItems.option6}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.studTerm7",
              "Stud Term 7"
            )}
            name="option7"
            checked={checkedItems.option7}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.studTerm8",
              "Stud Term 8"
            )}
            name="option8"
            checked={checkedItems.option8}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.studTerm9",
              "Stud Term 9"
            )}
            name="option9"
            checked={checkedItems.option9}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.studTerm10",
              "Stud Term 10"
            )}
            name="option10"
            checked={checkedItems.option10}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.studTerm11",
              "Stud Term 11"
            )}
            name="option11"
            checked={checkedItems.option11}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.ServiceGeneralNote",
              "Service General Note"
            )}
            name="option12"
            checked={checkedItems.option12}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
      </EahsForm> */}

      {/* buttons*/}
      <div className={eFormButtonsContainer}>
        {/* draft/pay/submit btn */}
        {
          (
            (action == null || action === "edit")
            ||
            (
              action === "approve"
              &&
              (
                formModel.eventName === "SentBack"
                ||
                (formModel.paymentStatus === "Pendding")
                // (formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice")
              )
            )
          ) && (
            <>
              {(formModel.eventName === "" || formModel.eventName === "Draft") &&
                <DraftBtn
                  key={translate("web.draft", "Draft")}
                  onClick={() => handelFormSubmit("Draft", "", "Draft")}
                  disabled={
                    formModel.eventName === "" ||
                      formModel.eventName === "Draft"
                      ? false
                      : true
                  }
                />
              }
              {userProfile?.participateWithoutPayment === true && formModel.eventName === "PendingPayment" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                <ApproveAndPayLaterBtn
                  selectedAccountId={profile?.value}
                  isApprove={false}
                  key={`<i class="fa-solid fa-wallet fa-lg marginrightleft-10"></i>                   
                          ${translate("web.payLater", "Pay Later")}
                          `}
                  onClick={() =>
                    handelFormSubmit("Draft", "no", "Pay")
                  }
                />
              )}
              {formModel.eventName === "PendingPayment" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                <SubmitAndPay
                  selectedAccountId={profile?.value}
                  key={translate("web.approvePay", "Approve And Pay")}
                  onClick={() =>
                    handelFormSubmit("Draft", "yes", "Pay")
                  }
                />
              )}

              {(formModel.eventName !== "PendingPayment" && action !== "view" || getServiceDefinitionByIdData.serviceFees === 0 || (formModel.eventName === "SentBack" && action !== "view")) && (
                <SubmitServiceBtn
                  key={translate("web.submit", "Submit")}
                  onClick={() =>
                    handelFormSubmit("Submit", "", "Submit")
                  }
                />
              )}
            </>
          )
        }
      </div>
    </>
  );
}
